import {fromJS} from 'immutable';

export const DEFAULT_STATE = fromJS({
    useEpicHeader: true
});

export default (state = DEFAULT_STATE) => {
    return state;
};
